import { PersonaFisicaDTO } from './persona-fisica-dto';
import { PersonaGiuridicaDTO } from './persona-giuridica-dto';

export class RappresentanteDTO {
	tipoRappresentante: string;
	codiceDelega: string;
	idPersona: string;
	personaFisica: PersonaFisicaDTO;
	personaGiuridica: PersonaGiuridicaDTO;
	codiceRegione: string;
	idSedeSelezionata: string;
	nuovaPersona: boolean;
}